import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ActionButtonComponent} from './action-button.component';
import {ButtonModule} from '../button/button.module';
import {ConfirmationButtonModule} from '../../../../components/common/button/confirmation-button/confirmation-button.module';
import {ActionServiceContainerModule} from "../action-service-container/action-service-container.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ButtonModule,
        ConfirmationButtonModule,
        ActionServiceContainerModule,
    ],
    declarations: [
        ActionButtonComponent
    ],
    exports: [
        ActionButtonComponent
    ],
})
export class ActionButtonModule {
}
